<template>
  <Sheet v-loading="loading.actions['systemNews']">
    <h2>{{routeTitle}}</h2>
    <div class="dataTables_scroll">
      <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
        <table style="margin: 0.5em;width:100%;" cellspacing="0" >
          <thead>
            <tr>
              <th style="width:9em; padding:0.5em; text-align: left;">發布日期</th>
              <th style="padding:0.5em 1.25em;text-align:left;">檔案內容</th>
              <th style="width:15em; padding:0.5em; text-align:left;">下載</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
        <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
          <tbody>
            <tr v-for="(item,index) in newsList" :key="index" :index="'0'+index" :name="'N2'+index"
              v-show="data2Len>0">
              <td style="width:10em; padding:0.25em 0.5em;">
                <i class="el-icon-time"></i>{{item.startDate | dateFormat}}&nbsp;<img v-if="true" src="@/assets/images/gif-new.gif" v-show="checkNewsTime(item.startDate)"/>
              </td>
              <td style="padding:0.25em 0.5em;">
                {{item.content}}
              </td>
              <td style="width:15em; padding:0.25em 0.5em;">
                <a target="_blank" style="display: flex;"
                  v-for="(f,index) in item.info" :key="index" :index="'0'+index" :name="'F2'+index"
                  :href="base.concat('api/News/getAttach/').concat(f.rowId)"
                  :title="f.name">
                  (<img src="@/assets/images/disk.png" /> {{getExtName(f.ext)}})
                </a>
              </td>
            </tr>
            <tr v-show="0 == data2Len">
              <td colspan="3" style="line-height:2.25em;">目前無表章下載~</td>
            </tr>
          </tbody>    
        </table>    
      </div>    
    </div>
  </Sheet>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import routeTitleMixin from './routeTitleMixin';
import {base} from '../constants';

export default {
  name: 'fileDownload',
  mixins: [routeTitleMixin],
  data () {
    return {
      data2Len: 0,
      base: base,
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('auth', ['name', 'userId', 'roleId']),
    ...mapState('systemNews',['newsList']),
  },
  filters: {  
    dateFormat:function(input) {   
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate(); 
       return  year+ '/' + month + '/' + day ; 
    }  
  },
  methods: {
    ...mapActions('systemNews', {
      getSystemNews: 'getSystemNews',
      clearList: 'clearNewsList',
    }),
    getExtName: function(name) {
      var ret = '';
      if (null != name) {          
        const words = name.split('.');
        var nLen = words.length;
        if (0 < nLen) {    
          ret = words[nLen - 1].toUpperCase();
        }
      }
      return ret;
    },
    checkNewsTime: function (startTime) {
      var date1 = new Date(startTime);
      var date2 = new Date();
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return (isNaN(diffDays) || (diffDays > 7) ? false : true);
    }
  },
  async created () {
    console.log('======created FileDownload =====');
    var curDate = new Date()
    var tObj = {
      id: 2,
      startDate:[curDate.getFullYear(), curDate.getMonth() + 1, curDate.getDate()].join('-'),
      val: [this.roleId]
    };
    
    await this.clearList();
    const {success} = await this.getSystemNews(tObj);
    if (success) {
      this.data2Len = this.newsList.length;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
